module.exports = __webpack_public_path__ + "static/media/eileenimage.a6348c49.png";